import { signInWithRedirect } from '@aws-amplify/auth';
import LoadingButton from '@mui/lab/LoadingButton';
import { Card, Container, Typography } from '@mui/material';
import { useState } from 'react';
import './Login.css';

export function Login() {
    const [loading, setLoading] = useState(false);
    const handleClick = async () => {
        setLoading(true);
        await signInWithRedirect()
    }
    return (
        <>
            <Container component="main" style={{ position: 'absolute', minHeight: '100vh', minWidth: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Card sx={{
                    height: 'auto',
                    width: '80%',
                    maxWidth: 400,
                    p: 2,
                    textAlign: 'center'
                }}>
                    <Typography component="h1" variant="h5" sx={{
                        marginTop: 4
                    }}>
                        Welcome to SPR Admin Portal
                    </Typography>
                    <LoadingButton
                        type="button"
                        onClick={handleClick}
                        loading={loading}
                        variant="contained"
                        sx={{ mt: 3, mb: 2, minWidth: "60%" }}
                    >
                        Login
                    </LoadingButton>
                </Card>
            </Container>
        </>
    )
}